import React, { useState } from 'react';
import { Box, ToggleButton, ToggleButtonGroup, Typography } from '@mui/material';
import { Person, Dashboard } from '@mui/icons-material';

const BUILD_VERSION = '2024-11-05-v3';

const AttendanceWrapper = () => {
  console.log('=== AttendanceWrapper loaded, version:', BUILD_VERSION, '===');
  
  const userStr = localStorage.getItem('user');
  const user = userStr ? JSON.parse(userStr) : null;
  
  // Check if user has admin privileges
  const isAdmin = user?.roles?.includes('admin') || user?.roles?.includes('madmin');
  const hasStaffRole = user?.roles?.includes('staff');
  
  // State for view toggle (default to admin view for admins)
  const [viewMode, setViewMode] = useState(isAdmin ? 'admin' : 'personal');
  
  const handleViewChange = (event, newView) => {
    if (newView !== null) {
      setViewMode(newView);
    }
  };
  
  // Load components
  const AttendanceDashboard = React.lazy(() => import('./Admin/AttendanceDashboard'));
  const Attendance = React.lazy(() => import('./Attendance'));
  
  return (
    <Box>
      {/* Show toggle only for admin users */}
      {isAdmin && (
        <Box sx={{ mb: 3, display: 'flex', justifyContent: 'center' }}>
          <ToggleButtonGroup
            value={viewMode}
            exclusive
            onChange={handleViewChange}
            aria-label="attendance view"
          >
            <ToggleButton value="personal" aria-label="personal attendance">
              <Person sx={{ mr: 1 }} />
              My Attendance
            </ToggleButton>
            <ToggleButton value="admin" aria-label="admin dashboard">
              <Dashboard sx={{ mr: 1 }} />
              Admin Dashboard
            </ToggleButton>
          </ToggleButtonGroup>
        </Box>
      )}
      
      {/* Render appropriate view */}
      <React.Suspense fallback={<div style={{padding: '20px'}}>Loading...</div>}>
        {viewMode === 'admin' && isAdmin ? (
          <AttendanceDashboard />
        ) : (
          <Attendance />
        )}
      </React.Suspense>
    </Box>
  );
};

export default AttendanceWrapper;
